module.exports = __webpack_public_path__ + "static/media/EditItemTable.3689f399.svg";